import * as React from 'react';
import { memo } from 'react';

import Icon from 'components/atoms/Icon';
export type IconNumberTypes = 'task' | 'tip' | 'recipe' | 'workout';

export type IconNumberProps = {
	type?: IconNumberTypes;
	count?: number;
	label?: string;
	modifier?: string;
	text?: string;
};

export const IconNumber = ({ type, count = 0, label, modifier = '', text }: IconNumberProps) => {
	const getClassNames = () => {
		const classes: string[] = [];

		if (modifier && modifier.length > 0) {
			classes.push(`a-icon-number--${modifier}`);
		}

		if (type && type.length > 0) {
			classes.push(`a-icon-number--${type}`);
		}

		return classes.join(' ');
	};

	return (
		<div className={`a-icon-number ${getClassNames()}`}>
			<div className="a-icon-number__figure">
				<div className="a-icon-number__count">{count}</div>
				<div className="a-icon-number__bevel" />
				<div className="a-icon-number__icon">{type && <Icon iconName={type} />}</div>
			</div>
			{label && (
				<span className="a-icon-number__label">
					{label}
					{text && <span className="a-icon-number__label-add">{text}</span>}
				</span>
			)}
		</div>
	);
};

IconNumber.displayName = 'IconNumber';

export default memo(IconNumber, (prevProps, nextProps) => {
	return prevProps.count === nextProps.count;
});
